import { actions as ACTION } from "./types";
import { surveyApi } from "@/services";

const actions = {
  [ACTION.SUBMIT_SURVEY]: async ({ state }, { surveyHandle }) => {
    try {
      const surveyData = state.survey;
      const res = await surveyApi.submitSurveyApi({ surveyHandle, surveyData });
      return res.data?.surveyFeedbackCreateByHandle?.id;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  },
};
export default actions;
